import { i18n } from '@/locale/i18n'
import { syncToLocal } from '../mixins'

export default {
  namespaced: true,

  mutations: {
    unlock (state, id) {
      return this.dispatch('db/slabs/update', {
        id: id,
        calculation_date: '',
        calculation_result: null,
        calculation_error: '',
        calculation_pdf: ''
      })
    }
  },

  actions: {
    // make it action as well, as we need it async too
    unlock (context, id) {
      return context.commit('unlock', id)
    },

    afterCreate (context) {
      syncToLocal(context)
    },

    // cancel updating a locked slab (calculation exists)
    beforeUpdate (context, record) {
      // let recordBeforeUpdate = context.state.slabs.data[record.id]
      // it's possible the id has just been changed, thus try $id
      const recordBeforeUpdate = context.getters['slabs/find'](record.id)

      if (recordBeforeUpdate) {
        // calculation in progress
        if (recordBeforeUpdate.calculation_busy && record.calculation_busy && !context.rootState.allowChanges) {
          uikit.modal.alert(i18n.t('locked_record_busy'))

          return false
        } else if (recordBeforeUpdate.calculation_pdf && record.calculation_pdf && !context.rootState.allowChanges) {
          // existing PDF
          uikit.modal.confirm(i18n.t('locked_record_pdf'), {
            labels: {
              ok: i18n.t('buttons.cancel'),
              cancel: i18n.t('buttons.unlock')
            }
          }).then(function () {
            // old ok (default selected) = cancel, do nothing
          }, function () {
            // cancel = Unlock
            // it would be nice to know here what's being changed by user before unlock, to add it here
            context.commit('slabs/unlock', record.id)
          })

          return false
        }

        // if productType, thickness or width has been changed, check if thickness & width are ok or have to be changed
        if (recordBeforeUpdate.floor_product_type_id !== record.floor_product_type_id || recordBeforeUpdate.floor_thickness !== record.floor_thickness || recordBeforeUpdate.floor_width !== record.floor_width) {
          let changed = []

          const productType = context.rootState.product_types[record.floor_product_type_id]

          // if product thickness not present in the new productType
          if (!(record.floor_thickness in productType.thickness)) {
            // update directly the new record here as we are in the middle of a Vuex update or shall we dispatch a separate update ?
            record.floor_thickness = parseInt(Object.keys(productType.thickness)[0], 10)

            changed.push(['floor', 'thickness'])
          }

          const productWidths = productType.thickness[record.floor_thickness].reduce((a, c) => {
            a.push(c.width)
            return a
          }, [])

          if (!productWidths.includes(parseInt(record.floor_width, 10))) {
            record.floor_width = parseInt(productWidths[0], 10)

            changed.push(['floor', 'width'])
          }

          const productData = context.rootGetters.productTypeData(record.floor_product_type_id, record.floor_thickness, record.floor_width)

          if (!productData.topping_thickness.includes(record.topping_thickness)) {
            record.topping_thickness = productData.topping_thickness[0]

            changed.push(['topping', 'thickness'])
          }

          if (record.support_left !== productData.support_length_def || record.support_right !== productData.support_length_def) {
            record.support_left = productData.support_length_def
            record.support_right = productData.support_length_def

            changed.push(['dimensions', 'support_length'])
          }

          // notify user of changed values
          if (changed.length) {
            uikit.notification('<span class="uk-margin-small-right" uk-icon="warning"></span>' + i18n.t('warning_changed_values', {
              fields: '<br /><br /><i>' + changed.map(field => i18n.t('tabs_sections.general.fieldsets.' + field[0] + '.legend') + ' ' + i18n.t('tabs_sections.general.fieldsets.' + field[0] + '.fields.' + field[1]).toLowerCase().replace(/\s+\(.*\)$/i, '')).join(', ')
            }) + '</i>', {
              pos: 'bottom-right',
              status: 'warning',
              timeout: 20000
            })
          }
        }
      }
    },

    afterUpdate (context) {
      syncToLocal(context)
    },

    beforeDelete (context, record) {
      // unblock element (if it has calculation or busy)
      context.commit('slabs/unlock', record.id)
    },

    afterDelete (context, record) {
      // delete dependencies: loads & openings
      context.dispatch('loads/delete', (load) => {
        return load.slab_id === record.id
      })

      context.dispatch('openings/delete', (opening) => {
        return opening.slab_id === record.id
      })

      syncToLocal(context)

      // server-side delete (only if real ID - positive)
      if (record.deleteFromServer) {
        // let project = context.getters['projects/find'](record.project_id)

        uikit.util.ajax('api/slab', {
          method: 'delete',
          // responseType: 'json', // this might not work with smart file result as blob
          data: JSON.stringify({
            id: record.id,
            // token: record.token,
            project: {
              id: record.project_id
              // ,token: project ? project.token : null
            }
          }),
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest'
          }
        }).then(function (xhr) {
          // do nothing
        }, function (error) {
          let details = error.xhr ? JSON.parse(error.xhr.responseText).message : 'Ooops ! We\'ve encountered an error :('

          // show notification if not 404 - not found
          if (!error.xhr || error.xhr.status !== 404) {
            uikit.notification(`<p class="uk-h3 uk-text-danger"><span class="uk-margin-small-right" uk-icon="ban"></span>${error.message}</p><p>${details}</p>`, {pos: 'bottom-right', status: 'danger'})
          }
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/slabs.js